import "./gcGlobalInit.ts";
import "./sentryInit.ts";
import "./chunkLoadErrorHandler.ts";
import "./metaPixelInit.ts";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { AppProviders } from "./AppProviders.tsx";
import "./wdyr.ts";
import { PortalManager } from "@chakra-ui/react";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AppProviders>
    <PortalManager>
      <App />
    </PortalManager>
  </AppProviders>,
);
